import { KOGTableRow } from "@/main/components/shared/boxGrid/styles";
import TooltipComponent from "@/main/components/shared/tooltip/tooltipComponent";
import { DistributionRegionResponse } from "@/main/models/response";
import { getTranslateByKey, haveIgnoreElement } from "@/main/services/utils";
import Clear from "@mui/icons-material/Clear";
import { TableCell, IconButton } from "@mui/material";
import * as S from "./styles";
import { useState } from "react";
import ModalRegion from "../../modalRegion/modalRegion";

interface IRowGridRegionProps {
	region: DistributionRegionResponse;
	index: number;
	setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
	setRegion: React.Dispatch<React.SetStateAction<DistributionRegionResponse | null>>;
	updateRowDataGrid: (row: DistributionRegionResponse) => void;
}

function RowGridRegion({ region, setIsModalOpen, setRegion, updateRowDataGrid }: Readonly<IRowGridRegionProps>) {
	const [isOpenModalRegion, setIsOpenModalRegion] = useState<boolean>(false);

	function openModalAndSetRegion(region: DistributionRegionResponse) {
		setRegion(region);
		setIsModalOpen(true);
	}

	function handleClickRow(e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) {
		if (haveIgnoreElement(e.target as HTMLElement)) return;
		setIsOpenModalRegion(true);
	}

	return (
		<>
			<KOGTableRow key={region.guid} onClick={handleClickRow}>
				<TableCell width="25%">{region.name}</TableCell>
				<TableCell width="15%">{region.zipCodeStart}</TableCell>
				<TableCell width="15%">{region.zipCodeEnd}</TableCell>
				<TableCell width="5%" align="center">
					<S.ActionButtons>
						<TooltipComponent title={`${getTranslateByKey("information.deleteRegion")}`}>
							<IconButton
								className="ignore-click"
								id={`id-region-delete-${region.guid}`}
								color="primary"
								onClick={() => openModalAndSetRegion(region)}
							>
								<Clear />
							</IconButton>
						</TooltipComponent>
					</S.ActionButtons>
				</TableCell>
			</KOGTableRow>

			<ModalRegion
				itemRegion={region}
				isOpenModal={isOpenModalRegion}
				updateRowDataGrid={updateRowDataGrid}
				closeModal={() => setIsOpenModalRegion(false)}
				setIsOpenModal={setIsOpenModalRegion}
			/>
		</>
	);
}

export default RowGridRegion;
